// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetIssuuEmbedDocumentRequestModel from '../../model/get-issuu-embed-document-request-model';
import GetIssuuEmbedDocumentRequestDTO from '../dto/get-issuu-embed-document-request-dto';
import dtoSchema from '../schemas/get-issuu-embed-document-request-schema';

export default abstract class GetIssuuEmbedDocumentRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetIssuuEmbedDocumentRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  */
  id?: string;

  static toModel(dto: DeepPartial<GetIssuuEmbedDocumentRequestDTO>): GetIssuuEmbedDocumentRequestModel;
  static toModel(dto: DeepPartial<GetIssuuEmbedDocumentRequestDTO> | undefined | null): GetIssuuEmbedDocumentRequestModel | undefined;
  static toModel(dto: DeepPartial<GetIssuuEmbedDocumentRequestDTO> | undefined | null): GetIssuuEmbedDocumentRequestModel | undefined {
    return dto ? new GetIssuuEmbedDocumentRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetIssuuEmbedDocumentRequestModel> | GetIssuuEmbedDocumentRequestModel): GetIssuuEmbedDocumentRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetIssuuEmbedDocumentRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetIssuuEmbedDocumentRequestModel, can not map to GetIssuuEmbedDocumentRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
